<template>
  <div v-loading="loading.searchPayables">
    <template v-if="showSearchButton && !value.length && serial_number">
      <div style="margin-bottom: 10px;">
        <el-button type="primary" @click="searchPayables" icon="el-icon-search">流水号搜索{{ recordTypeLabel }}</el-button>
      </div>
    </template>
    <div style="margin-bottom: 10px; display: flex; align-items: center; gap: 10px;">
      <span style="color: rgb(96, 98, 102); font-size: 12px;">{{ typeLabel }}</span>
      <el-select :disabled="!canChangeType" v-model="recordType" placeholder="请选择" @change="handleRecordTypeChange">
        <el-option v-for="item in recordTypes" :key="item.value" :label="item.label" :value="item.value" />
      </el-select>
    </div>
    <bean-nest-form
      :columns="columns"
      :value="value"
      :default-value="defaultValue"
      @change="$emit('change', $event)"
    />
  </div>
</template>

<script>
import { Vue, Component, Model, Prop, Emit } from 'vue-property-decorator';
import { formColumnsExtend as paymentAllocationFormCloumnsExtend } from '@/admin_entities/payment_allocation_detail.js';
import { displayText } from '@/custom_models_extend';
import _ from 'lodash';

@Component
export default class PayablesPayments extends Vue {
  @Prop({ type: String, default: '' }) type;
  @Prop({ type: [String, Number] }) customer_id;
  @Prop({ type: [String, Number] }) serial_number;
  @Prop({ type: String, default: 'payments' }) mode; // 'payments' or 'adjustments'
  @Prop({ type: Boolean, default: true }) showSearchButton; // 是否显示流水号搜索按钮

  // 根据 mode 设置不同的配置
  get recordTypes() {
    return [
      {
        value: 'SalesOrder',
        label: '销售订单',
      },
      {
        value: 'JushuitanOrder',
        label: '聚水潭订单',
      },
    ];
  }

  get typeLabel() {
    return this.mode === 'payments' ? '可支付对象类型' : '可调整对象类型';
  }

  get recordTypeLabel() {
    return this.mode === 'payments' ? '收款对象' : '调整对象';
  }

  get apiUrl() {
    return this.mode === 'payments' ? '/payments/payables' : '/adjustments/adjustables';
  }

  recordType = 'SalesOrder';

  loading = {
    searchPayables: false,
  }

  // 编辑的时候如果已经有数据了 不能更改类型
  get canChangeType() {
    const hasIdItem = (this.value || []).find(item => item.id);
    return !hasIdItem;
  }

  get defaultValue() {
    return {
      payable_type: this.recordType,
    }
  }

  @Model('change', { type: Array, default: () => [] }) value;

  created() {
    this.recordType = _.get(this.value, '0.payable.cn') || 'SalesOrder';
  }

  @Emit('change')
  handleRecordTypeChange() {
    // 选了不同类型，清空
    return [];
  }

  @Emit('change')
  changeValue(path, val) {
    const model = _.cloneDeep(this.value)
    _.set(model, path, val);
    return model;
  }

  columns(object, index) {
    const columnsDef = [
      {
        prop: 'payable_id',
        label: this.mode === 'payments' ? '可支付对象' : '可调整对象',
        renderCell: {
          required: true,
          component: 'app-read-options',
          props: {
            clearable: true,
            url: this.apiUrl,
            params: {
              customer_id_eq: this.customer_id,
              record_type_eq: this.recordType,
            },
            labelFormat: displayText,
          },
          on: {
            select: async (value) => {
              if (value) {
                const amount = value.cn === 'JushuitanOrder' ? Number(value.amount) : Number(value.sales_amount);
                if (amount && this.type === 'new' && !object.amount) {
                  await this.$nextTick();
                  this.changeValue(`${index}.amount`, amount);
                }
              }
            }
          },
          domProps: {
            style: 'width: 100%'
          }
        }
      },
      {
        key: 'amount',
        renderCell: {
          required: true,
        }
      },
    ];

    // 只在 payments 模式下显示关联订金
    if (this.mode === 'payments' && this.type === 'new') {
      columnsDef.push({
        prop: 'deposit_ids',
        label: '关联订金',
        renderCell: {
          component: 'app-read-options',
          props: {
            clearable: true,
            multiple: true,
            url: '/payments/read_options',
            params: {
              unallocated: true,
              kind_eq: 'deposit',
              customer_id_eq: this.customer_id
            },
            labelFormat: displayText,
          },
          domProps: {
            style: 'width: 100%'
          },
        },
      });
    }

    return paymentAllocationFormCloumnsExtend(columnsDef, { data: 'SalesOrder', type: this.type })
  }

  async searchPayables() {
    this.loading.searchPayables = true;
    try {
      const data = await this.$request.get('sales_orders/read_options', { customer_id_eq: this.customer_id, jushuitan_orders_so_id_eq: this.serial_number, page: 0 }, { loading: false, timeout: 3 * 60 * 1000 });
      if (data && data.length) {
        this.recordType = 'SalesOrder';
        this.$emit('change', data.map(salesOrder => ({
          payable_type: this.recordType,
          payable_id: salesOrder.id,
          amount: salesOrder.sales_amount,
        })))
      }
    } finally {
      this.loading.searchPayables = false;
    }
  }
}
</script>
